import { Divider, Link, Typography } from '@material-ui/core';

import { InfoCard } from '@backstage/core-components';
import { ScoreRuleLabels } from '@internal/ui-common';
import { scoreRules } from '../../utils/scoreRules';
import { useRef } from 'react';

export const RenovateGuideCard = () => {
  const guideLink = useRef({
    text: 'documentation',
    link: 'https://zf-scalar.atlassian.net/wiki/spaces/INFINITY/pages/3206185553/Renovate+-+How-to+guides#Renovate-has-opened-too-many-MR!-How-can-I-reduce-them%3F',
  });
  return (
    <InfoCard variant="gridItem" title="Recommended Action">
      <Typography component="span" variant="body1" color="textSecondary">
        <p>
          To benefit from Renovate, you need to act on your Merge Requests. If
          left unchecked, they can trigger excessive CI runs, leading to
          unnecessary load and costs. This dashboard flags Renovate Merge
          Requests that have been open for too long or have caused too many CI
          runs.
        </p>
        <p>
          Refer to our{' '}
          <Link href={guideLink.current.link} underline="always">
            {guideLink.current.text}
          </Link>{' '}
          to learn how to reduce the number of CI runs.
        </p>
        <Divider />
        <ScoreRuleLabels scoreRules={scoreRules} />
      </Typography>
    </InfoCard>
  );
};
